import { useState } from "react";
import { VariablesContext } from "./context";

const VariablesProvider = ({ children }) => {
  const [isDaily, setIsDaily] = useState(false);

  return (
    <VariablesContext.Provider value={{ isDaily, setIsDaily }}>
      {children}
    </VariablesContext.Provider>
  );
};

export default VariablesProvider;
